
export function TreeCategory({
  nodes,
  categoryIds,
  toggleCategory,
  level = 0,
}: any) {
  return (
    <div>
      {nodes?.map((node: any) => {
        const isChecked = categoryIds.includes(node.id);
        const hasChildren = node.children && node.children.length > 0;

        return (
          <div key={node.id} className="py-1">
            <label
              className="flex items-center cursor-pointer gap-2"
              style={{
                marginLeft: level * 12, // indent theo cấp
              }}
            >
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => toggleCategory(node)}
              />
              <span className="text-sm text-gray-700">
                {node.name}
              </span>
            </label>

            {/* Render children */}
            {hasChildren && (
              <TreeCategory
                nodes={node.children}
                categoryIds={categoryIds}
                toggleCategory={toggleCategory}
                level={level + 1}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
